<template>
  <div>
    <!-- Step 1 — credentials. Step 2 (2FA challenge) is rendered when the
         server signals requires2fa on the signin response. -->
    <template v-if="!challenge">
      <vs-input v-validate="'required|email|min:3'" data-vv-validate-on="blur" name="email" icon-no-border
        icon="icon icon-user" icon-pack="feather" label-placeholder="Email" v-model="email" class="w-full" />
      <span class="text-danger text-sm">{{ errors.first('email') }}</span>
      <vs-input data-vv-validate-on="blur" v-validate="'required|min:6|max:64'" type="password" name="password"
        icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="Password" v-model="password"
        class="w-full mt-6" />
      <span class="text-danger text-sm">{{ errors.first('password') }}</span>
      <br />
      <div class="flex flex-wrap justify-between mb-3">
        <vs-button color="primary" type="border" @click="registerUser">Register</vs-button>
        <vs-button color="success" :disabled="!validateForm" @click="loginJWT">Login</vs-button>
      </div>
      <div class="flex justify-center mt-2 mb-3">
        <router-link to="/pages/forgot-password" class="text-sm">Forgot password?</router-link>
      </div>
    </template>
    <template v-else>
      <TwoFAChallenge
        :challenge-token="challenge.challengeToken"
        :method="challenge.method"
        @cancel="challenge = null"
      />
    </template>
    <hr class="mt-8 mb-8" style="    border: 0;
    height: 1px;
    background: #333;
    background-image: linear-gradient(to right, #ccc, #333, #ccc);" />

    <div class=" mx-auto">
      <h4 class="mb-4">Modules</h4>
      <!-- Section des Boutons Verticalement Empilés -->
      <div class="flex flex-col space-y-4 mb-6">

        <vs-button color="danger" type="gradient" icon-pack="feather" icon="icon-clock" icon-after @click="attendance"
          class="w-full" aria-label="Démarrer ou arrêter la présence">
          Employee attendance
        </vs-button>

        <vs-button color="danger" type="gradient" icon-pack="feather" icon="icon-heart" icon-after @click="transporter"
          class="w-full" aria-label="Ouvrir le formulaire de transporteur">
          Transporter form
        </vs-button>

        <vs-button color="warning" type="gradient" icon-pack="feather" icon="icon-box" icon-after @click="traceability"
          class="w-full" aria-label="Accès application Production">
          PRODUCTION
        </vs-button>

      </div>
    </div>
  </div>
</template>

<script>
import TwoFAChallenge from './TwoFAChallenge.vue'
import { TWOFA_SETUP_FLAG, LOGIN_NOTICE_KEY } from '@/helpers/roleAccess.js'

const LOGIN_NOTICES = {
  twofa_required: 'Two-factor authentication is now required for your role. Please sign in to set it up.',
  twofa_setup_expired: 'Your two-factor setup session expired. Please sign in again to restart it.'
}

export default {
  components: { TwoFAChallenge },
  created () {
    // Activation 2FA forcée abandonnée (onglet fermé, retour au login) : le
    // token de configuration ne doit pas passer pour une session.
    if (localStorage.getItem(TWOFA_SETUP_FLAG)) {
      const keys = [
        'accessToken', 'login-id', 'login-username', 'login-avatar', 'login-email', 'login-roles',
        'login-language', 'login-broker', 'login-date', 'login-readonly', TWOFA_SETUP_FLAG
      ]
      keys.forEach(k => localStorage.removeItem(k))
    }
    const notice = localStorage.getItem(LOGIN_NOTICE_KEY)
    if (notice) {
      localStorage.removeItem(LOGIN_NOTICE_KEY)
      this.$vs.notify({
        title: 'Two-factor authentication',
        text: LOGIN_NOTICES[notice] || notice,
        iconPack: 'feather',
        icon: 'icon-shield',
        color: 'warning',
        position: 'bottom-right',
        time: 10000
      })
    }
  },
  data () {
    return {
      email: '',
      password: '',
      challenge: null // { challengeToken, method } when 2FA challenge needed
      /*email: 'chady.makki@gmail.com',
      password: 'safe0909'*/
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT () {

      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then(result => {
          this.$vs.loading.close()
          // Server signaled 2FA required — pivot to challenge view.
          if (result && result.requires2fa) {
            this.challenge = { challengeToken: result.challengeToken, method: result.method }
            
          }
          // mustEnable2fa: the auth action already routed us; the global
          // mandatory-2FA modal will appear on the next page.
        })
        .catch(error => {
          this.$vs.loading.close()
          if (error.message === 'OK') {
            this.$vs.notify({
              title: 'Information',
              text: 'Welcome back!',
              iconPack: 'feather',
              icon: 'icon-thumbs-up',
              color: 'success',
              position: 'bottom-right',
              time: 4000
            })
          } else {
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'bottom-center',
              time: 4000
            })
          }
        })
    },
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => { })
    },
    attendance () {
      window.location.href = 'https://xylo-pontaj.codesinn.com/'
    },
    traceability () {
      window.location.href = 'https://xylo-trace.codesinn.com/'
    },
    transporter () {
      if (!this.checkLogin()) return
      this.$router.push('/transporter/forms').catch(() => { })
    }
  }
}

</script>
